import axios from 'axios';
import localStorageConstants, { getFromLocalStorage } from '../constants/localstorage';
import { setLoader, showAlert, hideAlert } from '../redux/global/globalSlice';
import { ExecuteInterface } from './interfaces/ExecuteInterface';

export const execute = ({
  method = 'get',
  route,
  data,
  params,
  headers,
  responseType,
  server,
  onUploadProgress,
  dispatch,
  showLoader = false,
  showNotificationError = true,
  redirectOn401 = false,
  useAuthToken = false,
}: ExecuteInterface) =>
  new Promise((resolve, reject) => {
    if (dispatch && showLoader) {
      setLoader(dispatch, showLoader);
    }
    const isFixTescucha = window.location.pathname.includes('fix-tescucha');
    // Obtener el valor de la variable de entorno o usar window.location.hostname
    const domainValue = process.env.REACT_APP_DOMAIN || window.location.hostname;

    const dynamicHeaders = {
      context: isFixTescucha ? 'fix-tescucha' : 'tescucha',
      domain: domainValue,
    };

    const requestObject = {
      method,
      data,
      params,
      onUploadProgress,
      responseType,
      url: route,
      baseURL: '/context/tescucha/api/v1',
      headers: {
        ...(useAuthToken ? { Authorization: `Bearer ${getFromLocalStorage(localStorageConstants.token)}` } : {}),
        ...dynamicHeaders, //  headers dinámicos
        ...headers,
      },
    };

    if (server) requestObject.baseURL = server;
    axios
      .request(requestObject)
      .then(response => {
        if (dispatch && showLoader) setLoader(dispatch, false);
        resolve(response.data);
      })
      .catch(({ response }) => {
        if (dispatch && showLoader) setLoader(dispatch, false);
        if (response && response.status === 404) {
          if (showNotificationError) {
            if (dispatch) {
              showAlert(dispatch, {
                message: 'No se encontraron datos',
                type: 'INFO',
                timeout: 6000,
              });
            }
          }
          reject(new Error('No se encontraron datos'));
        } else if (response && `${response.status}` === '401') {
          if (redirectOn401) {
            if (dispatch) hideAlert(dispatch);
            window.open(process.env.REACT_APP_ssoUrl, '_self');
          } else if (showNotificationError) {
            if (dispatch) {
              showAlert(dispatch, {
                message:
                  (response && response.data && response.data.message) ||
                  'Error inesperado, intente de nuevo mas tarde.',
                type: 'ERROR',
                timeout: 6000,
              });
            }
            reject();
          } else {
            reject();
          }
          // window.location.href = "/inventario/login";
        } else if (response) {
          if (showNotificationError) {
            if (dispatch) {
              showAlert(dispatch, {
                message:
                  (response && response.data && response.data.message) ||
                  'Error inesperado, intente de nuevo mas tarde.',
                type: 'ERROR',
                timeout: 6000,
              });
            }
            reject();
          } else {
            reject(response ? response.data : 'Error inesperado, intente de nuevo mas tarde.');
          }
        } else {
          if (dispatch) {
            showAlert(dispatch, {
              message: 'Ocurrio un problema con tu conexión, favor de verificarlo e intentar de nuevo mas tarde.',
              type: 'ERROR',
              timeout: 6000,
            });
          }
          reject();
        }
      });
  });
